export const StyleVariables = {
  /* primary color shades */
  primaryLight: '#5AB8CF',
  primaryMain: '#105968',
  primaryDark: '#00303D',
  contrasText: '#fff',
  primaryGrey: '#263238',
  primaryBlack: '#000000',
  primaryDarkBlue: '#010713',
  surface: '#F9FAFB',
  secondaryText: '#777777',
  surfaceWhite: '#fff',
  fieldBorder: '#EFEFEF',
  tableHeader: '#FBFBFB',
  tableBorder: 'rgba(224, 224, 224, 0.5)',

  /* shades of primary light */
  colorPrimaryLight10: '#E8F3F5',
  colorPrimaryLight20: '#D1E7EC',
  colorPrimaryLight30: '#BADBE2',
  colorPrimaryLight40: '#A3CFD8',
  colorPrimaryLight50: '#8DC4CF',
  colorPrimaryLight60: '#76B8C5',
  colorPrimaryLight70: '#5FACBB',
  colorPrimaryLight80: '#48A0B1',
  colorPrimaryLight90: '#3194A8',
  /* shades of blue grey*/
  colorBlueGrey1: '#263238',
  colorBlueGrey2: '#37474F',
  colorBlueGrey3: '#455A64',
  colorBlueGrey4: '#546E7A',
  colorBlueGrey5: '#607D8B',
  colorBlueGrey6: '#78909C',
  colorBlueGrey7: '#90A4AE',
  colorBlueGrey8: '#B0BEC5',
  colorBlueGrey9: '#CFD8DC',
  colorBlueGrey10: '#CFD8DC',

  /* Tone colors */
  colorSecondaryOrange: '#F7951E',
  colorSecondaryRed: '#E40001',
  colorSecondarySunny: '#FED766',
  colorSecondaryOldRose: '#B12D54',
  colorSecondaryGreen: '#22B02E',
  colorSecondarySuccess: '#00C851',
  colorSecondarySuccessDark: '#007E33',
  colorSecondarySuccessBg: '#E6FAEE',
  colorSecondaryError: '#FF4444',
  colorSecondaryLight: '#ff8a80',
  colorSecondaryErrorDark: '#CC0000',
  colorSecondaryErrorBg: '#FFEDED',
  colorSecondaryWarning: '#FFBB33',
  colorSecondaryWarningDark: '#FF8800',
  colorSecondaryInfo: '#2196F3',
  colorSecondaryInfoDark: '#1976D2',
}
